import React from 'react';

import PropTypes from 'prop-types';

import { Stack, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/system';

import { VpIcon } from './';
import styles from './VpDialogTitle.module.less';

export const VpDialogTitle = ({
  onClose = null,
  leftContent = '',
  centerContent = '',
  subtitle = '',
  contextMenu = null
}) => {
  return (
    <>
      <DialogTitle className={styles.titleStyles}>
        <Stack flexDirection="row" justifyContent="space-between" width="100%">
          <Box className={`${styles.divStyles} `}>{leftContent}</Box>
          <Box className={`${styles.divStyles} ${styles.centerContent}`}>{centerContent}</Box>
          <Box className={styles.leftGrid}>
            {contextMenu && contextMenu}
            {onClose && (
              <IconButton
                className={styles.buttonStyles}
                edge="end"
                onClick={onClose}
                fontSize="large"
              >
                <VpIcon icon="X" />
              </IconButton>
            )}
          </Box>
        </Stack>
        {subtitle && <Typography className={`${styles.subtitleStyles}`}>{subtitle}</Typography>}
      </DialogTitle>
    </>
  );
};

VpDialogTitle.propTypes = {
  leftContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  centerContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func,
  subtitle: PropTypes.string,
  contextMenu: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDialogTitle.jsx